<template>
    <q-layout view="hHh lpR fff">
        <SiteHeader></SiteHeader>

        <q-page-container>
            
            <div class="row">
                <div class="col-12">
                    <q-img alt="city scape" :no-transition="true" :no-spinner="true" :loading="'lazy'" id="bghead" style="max-height:500px;" :position="'0% 25%'" :fit="'cover'" class="" src="/splash.jpg">
                        <div class="row absolute-top text-center" style=" background: rgba(255, 255, 255, 0.77)">
                            <div class="col-3 text-center q-px-xs">
                                <q-img alt="bcal logo" class="col" src="/img/bcal/logo1.png" style="max-width:130px">
                                </q-img>
                            </div>
                            <div class="col-9 ">
                                <h1 class="text-black text-center" :style="{ fontSize: HeaderFontSizes[0] }">
                                    <span class="text-black">FREE</span> Austin Area Apartment Locator Service
                                </h1>
                                <h2 class="text-grey-9 q-pt-xs" style="font-style:italic; font-family:'Times New Roman', Times, serif" :style="{ fontSize: HeaderFontSizes[1] }">
                                    Sit back and relax. We've got your home search covered.
                                </h2>
                                <div class="q-mt-md" style="font-size:14px;"><a class="text-green-8 text-weight-bold" style="text-decoration:dashed" :href="'tel:' + PhoneNumberDigits">{{PhoneNumber}}</a>
                                                                             <span class="text-grey-5 q-px-md">- or - </span><q-btn href="/home/search" style="top:-1px" color="positive" size="xs" dense label="Search Online" /></div>                                
                                
                            </div>
                        </div>
                    </q-img>
                    <h3 class="text-white text-center q-py-xs bg-green-8 shadow-4" :style="{ fontSize: HeaderFontSizes[2]}">
                        Serving Austin, Pflugerville, Round Rock, Georgetown,<br v-if="$q.screen.xs" /> Leander, Cedar Park, Hutto, Manor, Buda, Kyle &amp; Bee-Cave
                    </h3>
                </div>


            </div>
                       
            <div class="row justify-center items-center q-pa-md shadow-5">


                <div class="col-12 col-md-6 text-center  q-pb-md" style="background-color:rgba(255,255,255,0.8)">

                    <div>
                        <div class="" style="font-size:24px;">Call Us <a style="color:black;text-decoration:dashed" :href="'tel:' + PhoneNumberDigits">{{PhoneNumber}}</a></div>
                        <div class="q-ma-sm text-grey-5">-OR-</div>
                        <q-btn href="/home/search" color="red" icon="search" label="Search Online" />
                        <div class="q-mt-sm text-weight-bold">No Account Needed</div>
                        <div class="text-weight-bold">No Payment Information Needed<br /><span class="text-grey-9 text-weight-light">(our service is at no cost to you)</span></div>
                    </div>

                </div>

                <div class="col-12 col-md-6 text-center  q-pb-md" style="border-left:1px dotted lightgrey; background-color:rgba(255,255,255,0.8)">
                    <div class="text-h5 text-weight-bold q-pt-md text-black-50" style="font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif">
                        Need an apartment or house in Austin?
                    </div>
                    <div class="q-pa-lg">
                        <p>We've Got Verified and Current Move-In Specials<br />&amp; Rent Prices All Around Austin</p>

                        <h1 style="font-weight:bold;" class="text-h5 text-positive">Now Offering $100 Rent Rebate<br /></h1>
                        <small class="text-overline"><a style="color:lightgrey" href="javascript:void(0)">
    Just Use Our (free) Service<sup>*</sup>
    <q-tooltip max-width="500px" class="bg-black">
        *Total Rebate is 10% of your first month's rent amount or $100, whichever is lower.<br /><br />Payment of this commission rebate is contingent on the landlord / complex paying us for our services which, in turn, is contingent upon you listing our Agent/Brokerage on your guest card and lease application as the person who referred you.<br /><br />Your rebate will be paid in response to our brokerage receiving commission payment from landlord / apartment complex which could be 1 to 3 months or more after your lease begins. The actual timeframe is ultimately dependent on the apartment complex / landlord.<br /><br />Payment will be made to you in the form of a check or money order and will be mailed via U.S. Postal Service to the address we have on file. Offer valid for 12+ month leases.
    </q-tooltip>
</a></small>

                    </div>

                </div>

            </div>
            <div v-if="Showcase.Loaded">
                <div class="row justify-center shadow-6 bg-white q-pb-lg">
                    <div class="col-12 q-pa-xl">
                        <div class="row justify-center">
                            <div class="col-12 text-h3 text-weight-medium text-grey-6 text-center">
                                Today's Apartment Showcase
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-subtitle2 text-italic text-grey-5 text-center">
                                it feels like home
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 self-center text-center Frames">
                        <img class="Frame" alt="Apartment Showcase" :src="Showcase.Image" style="width: 90%; transform: scaleX(-1);" />
                    </div>

                    <div class="col-12 col-sm-6 text-start q-pa-md q-pl-xl self-center items-center">
                        <q-timeline class="" layout="dense" color="green-5">

                            <template v-if="Showcase.Stats" v-for="(text, idx) in Showcase.Stats">
                                <q-timeline-entry 
                                                  v-if="idx < 7"
                                                  title=""
                                                  subtitle=""
                                                  side="right"
                                                  icon="check">
                                    <div style="position:relative;top:-15px;" class="text-green-5 text-weight-medium">
                                        <span v-html="text"></span>
                                    </div>
                                </q-timeline-entry>
                            </template>
                        </q-timeline>
                        <div>
                            <a :href="'/home/showcase/?property=' + Showcase.Id">
                                <q-btn color="primary" icon="settings_suggest">&nbsp; Get Full Details</q-btn>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-center bg-grey-1 shadow-6">
                <div class="col-12 col-md-9 q-pa-lg">
                    <q-timeline :layout="TimelineLayout" color="secondary" id="process">
                        <q-timeline-entry heading class="text-primary">
                            <h3 class="text-h5">How Does "Apartment Locating" Work?</h3>
                            <span class="text-italic text-grey-7">(Never any cost to you. Never any obligation. Never any catches.)</span>
                        </q-timeline-entry>

                        <q-timeline-entry title="1. Submit Your Search"
                                          color="orange"
                                          side="left">
                            <div>
                                Fill out our 2-minute form to let us know your apartment preferences, and we'll take care of the rest.
                            </div>
                        </q-timeline-entry>

                        <q-timeline-entry title="2. We Process Your Request"
                                          side="right"
                                          icon="search">
                            <div>
                                Your Locator will search to find your ideal home match. Our Agents are Austin Metro experts who'll select the best options based on your needs and current pricing and specials.
                            </div>
                        </q-timeline-entry>

                        <q-timeline-entry title="3. Search Result Delivery"
                                            side="left"
  color="orange">
                            <div>
                                Receive a text with a direct link to view your personalized report that includes pricing, deposits and any other relevant apartment data.
                            </div>
                        </q-timeline-entry>

                        <q-timeline-entry title="4. Tour Apartment"
                                        
                                          icon="done_all">
                            <div>
                                Select your preferred properties on our website, and your Locator Agent will schedule apartment tour appointments for you. Act quickly as prices and specials may change.
                            </div>
                        </q-timeline-entry>

                        <q-timeline-entry title="5. Look &amp; Lease"
                                          icon="sports_score"
                                            side="left"
  color="orange">
                            <div>
                                All that's left is for you to take some tours, decide which property you loved the most and sign your lease!<br /><br />Welcome Home!
                            </div>
                        </q-timeline-entry>


                    </q-timeline>


                </div>

            </div>

            <div class="row justify-center text-center q-pa-lg bg-blue-1">
                <div class="col-12">
                    <div>
                        <q-btn href="/home/search" color="red" icon="search" label="Search Apartments" />
                        <div class="q-mt-sm text-weight-bold">No Account Needed</div>
                        <div class="text-weight-bold">No Payment Information Needed<br /><span class="text-grey-9 text-weight-light">(our service is at no cost to you)</span></div>
                    </div>
                </div>
            </div>


            <div v-if="Blog != null && Blog.Title" class="row justify-center blog-feature q-pa-lg" :style="{backgroundImage: 'url(' + Blog.PreviewImageUrl + ')'}">
                <div class="overlay"></div> <!-- Overlay div -->
                <div class="col-12">
                    <div>
                        <q-item>
                            <q-item-section side top>
                                <q-badge class="q-pa-sm" label="Austin, Apartments and Lifestyle News" />
                            </q-item-section>
                        </q-item>

                        <q-item class="" style="">
                            <q-item-section class="text-h6">
                                <q-item-label lines="1" overline class="text-grey-5 text-weight-bold q-mb-md" style="font-size:24px;"><h3>{{Blog.Title}}</h3></q-item-label>
                                <q-item-label class="text-white" style="font-size:12px" caption lines="3">{{BlogCleanContent}}</q-item-label>
                            </q-item-section>

                        </q-item>

                        <q-item class="q-mb-md q-mt-md">
                            <q-item-section avatar>
                                <q-avatar icon="bungalow" color="green">
                                </q-avatar>
                            </q-item-section>

                            <q-item-section>
                                <q-item-label>by Bat City Apartment Locators</q-item-label>
                                <q-item-label class="text-grey-5" caption lines="1">{{ Blog.PublishDate }}</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <a href="/home/news">
                                    <q-btn size="md" color="green" class="text-white">Read More</q-btn>
                                </a>
                            </q-item-section>
                        </q-item>
                    </div>
                </div>
            </div>

            <div class="q-mt-md q-mb-xl">
                <div class="row justify-center">
                    <div class="col-12 text-center text-h5 text-weight-bold q-pa-md text-blue-5">
                        Here's What You Get With Our Locating Service
                    </div>
                </div>


                <div class="row q-col-gutter-md justify-center items-stretch">



                    <div class="col-md-3 col-sm-6">
                        <q-card class="full-height">

                            <q-img src="/img/bcal/concierge.jpg" alt="Free concierge apartment locator in Austin" :fit="'fill'">
                                <div class="absolute-bottom">
                                    <div class="text-h6">Full Service Concierge</div>
                                    <div class="text-subtitle2">> just look-and-lease</div>
                                </div>
                            </q-img>
                            <q-card-section class="q-pa-md">
                                Reclaim your time! Our licensed Austin Apartment Locators do all the searching, all the calling, all the verifying, all the scheduling and all the negotiating on your behalf.  All you have to do is tour the places you liked best and decide on which one to lease. It couldn't be easier.
                            </q-card-section>
                        </q-card>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <q-card class="full-height">

                            <q-img src="/img/bcal/secret.jpg" alt="Specialized databases help us find the perfect place for you." :fit="'fill'">
                                <div class="absolute-bottom">
                                    <div class="text-h6">The Secret Sauce</div>
                                    <div class="text-subtitle2">> we have all the data!</div>
                                </div>
                            </q-img>
                            <q-card-section class="q-pa-md">
                                Not only do we have access to every rental house, duplex and condo that's privately listed in the MLS, we also maintain access to proprietary Apartment databases that show us heaps of listing information that's not readily available on the Apartment rental sites that you're used to using.
                            </q-card-section>
                        </q-card>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <q-card class="full-height">

                            <q-img src="/img/bcal/options.jpg" alt="No matter what your requirements are, we can help." :fit="'fill'">
                                <div class="absolute-bottom">
                                    <div class="text-h6">Special Orders</div>
                                    <div class="text-subtitle2">> we have all the options!</div>
                                </div>
                            </q-img>
                            <q-card-section class="q-pa-md">
                                It doesn't matter what your special request or must-have amenity is, we'll find it for you or we'll go down trying! Need an apartment with a private yard? Got you covered! Need that granite top kitchen island? We know where to find it. Concerned about bad credit or past convictions? Don't worry about it. We know all the spots.
                            </q-card-section>
                        </q-card>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <q-card class="full-height">

                            <q-img src="/img/bcal/rebate.jpg" alt="Earn a rebate on your rent by renting through us." :fit="'fill'">
                                <div class="absolute-bottom">
                                    <div class="text-h6">Free Money</div>
                                    <div class="text-subtitle2">> because moving is expensive enough!</div>
                                </div>
                            </q-img>
                            <q-card-section class="q-pa-md">
                                Do you happen to like cash? You're in luck. Not only are we going to work hard to get you the most valuable move-in specials possible, but as a <span class="text-weight-bold">thank you</span> for leasing your next place through us, we're offering up to a $100 rebate off of one month's rent. <a href="javascript:void(0)">
                                    *offer details
                                                                                                                                                                                                                                                                                                                                        <q-tooltip max-width="500px" class="bg-black">
                                                                                                                                                                                                                                                                                                                                            *Total Rebate is 10% of your first month's rent amount or $100, whichever is lower.<br /><br />Payment of this commission rebate is contingent on the landlord / complex paying us for our services which, in turn, is contingent upon you listing our Agent/Brokerage on your guest card and lease application as the person who referred you.<br /><br />Your rebate will be paid in response to our brokerage receiving commission payment from landlord / apartment complex which could be 1 to 3 months or more after your lease begins. The actual timeframe is ultimately dependent on the apartment complex / landlord.<br /><br />Payment will be made to you in the form of a check or money order and will be mailed via U.S. Postal Service to the address we have on file. Offer valid for 12+ month leases.
                                                                                                                                                                                                                                                                                                                                        </q-tooltip>
                                </a>
                            </q-card-section>
                        </q-card>
                    </div>

                </div>
            </div>



        </q-page-container>

        <q-footer bordered class="bg-black text-grey-2">
            <q-toolbar>
                <q-toolbar-title style="font-size:12px">
                    <div>"Bat City Apartments" is a website provided by <a class="text-light-blue-1" target="_blank" href="https://www.villayn.com/">Villayn Realty Group</a>, Brokered by Central Metro Realty.</div>
                    <div><a class="text-light-blue-1" target="_blank" href="/home/privacy">> Our Privacy Policy</a></div>
                </q-toolbar-title>
                <q-toolbar-title style="font-size:12px;">
                    <a href="https://www.villayn.com/_files/ugd/9e1f28_677257b5fff449b39d0970b39cbdac7e.pdf" target="_blank" class="wixui-rich-text__text"><span style="color:#008AFC;" class="wixui-rich-text__text"><span style="text-decoration:underline;" class="text-light-blue-1">Texas Real Estate Commission Information About Brokerage Services</span></span></a>
                    <br/>
                    <a href="https://www.villayn.com/_files/ugd/9e1f28_b11aa89370c74e6e91d1db456188b2ab.pdf" target="_blank" class="wixui-rich-text__text"><span style="color:#008AFC;" class="wixui-rich-text__text"><span style="text-decoration:underline;" class="text-light-blue-1">Texas Real Estate Commission Consumer Protection Notice</span></span></a>
                </q-toolbar-title>
            </q-toolbar>
        </q-footer>
    </q-layout>
</template>

<script>

    import axios from '/src/components/NovaAxios.js';
    import { toast } from 'vue3-toastify';
    import { nextTick, ref } from 'vue';
    import { usePortalStore } from '/src/stores/portal';
    
    import SiteHeader from '@components/Aside/SiteHeader.vue';

    export default {
        components: {
            SiteHeader
        },
        data() {
            return {                      
                PhoneNumber: '(512) 200-4798',
                PhoneNumberDigits: '5122004798',
                Showcase: {
                    Loaded: false,
                    Id: 0,
                    Image: '',
                    Stats: []
                },
                Blog: {},
                HeaderTop: '0%',
                Store: null,
                Services: [
                    {
                        Title: 'Full Service Concierge',
                        SubTitle: "> just look and lease",
                        Image: '/img/bcal/concierge.jpg',
                        Text: `Reclaim your time! Our licensed Austin Apartment Locators do all the searching, all the calling, all the verifying, all the scheduling and all the negotiating on your behalf. All you have to do is tour the places you liked best and decide on which one to lease. It couldn't be easier.`
                    },
                    {
                        Title: 'The Secret Sauce',
                        SubTitle: "> we have all the data!",
                        Image: '/img/bcal/secret.jpg',
                        Text: `Not only do we have access to every rental house, duplex and condo that's privately listed in the MLS, we also maintain access to proprietary Apartment databases that show us heaps of listing information that's not readily available on the Apartment rental sites that you're used to using.`
                    },
                    {
                        Title: 'Special Orders',
                        SubTitle: "> we have all the options",
                        Image: '/img/bcal/options.jpg',
                        Text: `It doesn't matter what your special request or must-have amenity is, we'll find it for you or we'll go down trying! Need an apartment with a private yard? Got you covered! Need that granite top kitchen island? We know where to find it. Concerned about bad credit or past convictions? Don't worry about it. We know all the spots.`
                    },
                    {
                        Title: 'Free Money',
                        SubTitle: "> because moving is expensive enough!",
                        Image: '/img/bcal/rebate.jpg',
                        Text: `Do you happen to like cash? You're in luck. Not only are we going to work hard to get you the most valuable move-in specials possible, but as a <span class="text-weight-bold">thank you</span> for leasing your next place through us, we're offering up to a $100 rebate off of one month's rent.`,
                        Tooltip: { text: 'offer details', desc: `*Total Rebate is 10% of your first month's rent amount or $100, whichever is lower.<br /><br />Payment of this commission rebate is contingent on the landlord / complex paying us for our services which, in turn, is contingent upon you listing our Agent/Brokerage on your guest card and lease application as the person who referred you.<br /><br />Your rebate will be paid in response to our brokerage receiving commission payment from landlord / apartment complex which could be 1 to 3 months or more after your lease begins. The actual timeframe is ultimately dependent on the apartment complex / landlord.<br /><br />Payment will be made to you in the form of a check or money order and will be mailed via U.S. Postal Service to the address we have on file. Offer valid for 12+ month leases.`}
                    }
                ],
            }
        },
        computed: {
            BlogCleanContent: function () {
                return this.Blog.ContentBody.replace(/<\/?[^>]+(>|$)/g, "");
            },
            TimelineLayout: function () {
                return this.$q.screen.lt.sm? 'dense' : (this.$q.screen.lt.sm ? 'loose' : 'loose')
            },
            HeaderFontSizes: function () {
                let headerSize, subHeaderSize, accentSize;

                // Define a key representing the current screen size
                const screenSize = this.$q.screen.name; // sizeName gives 'xs', 'sm', 'md', 'lg', 'xl'
                switch (screenSize) {
                    case 'xs':
                        headerSize = '16px';
                        subHeaderSize = '14px';
                        accentSize = '10px';
                        break;
                    case 'sm':
                        headerSize = '18px';
                        subHeaderSize = '16px';
                        accentSize = '11px';
                        break;
                    case 'md':
                        headerSize = '24px';
                        subHeaderSize = '20px';
                        accentSize = '12px';
                        break;
                    case 'lg':
                        headerSize = '30px';
                        subHeaderSize = '26px';
                        accentSize = '14px';
                        break;
                    case 'xl':
                        headerSize = '36px';
                        subHeaderSize = '30px';
                        accentSize = '16px';
                        break;
                    default:
                        // Fallback sizes
                        headerSize = '16px';
                        subHeaderSize = '14px';
                }

                return [headerSize, subHeaderSize, accentSize ];
            }
        },
        methods: {
           
        },
        provide: {
        },
        created() {
            this.Store = usePortalStore();
            this.Store.ContentViewComponent = _VIEW_KEY;
            this.Store.Authenticated = _AUTHENTICATED;
        },
        async mounted() {
            try {
                this.Showcase = _SHOWCASE
                this.Blog = _BLOG

                if (_REFER && _REFER.toLowerCase().includes("paul")) {
                    this.PhoneNumberDigits = '5123207872'
                    this.PhoneNumber = '(512) 320-7872'
                }
            } catch (e) {
            }

            nextTick(() => window.prerenderReady = true);
        }

    }

</script>

<style>
    .q-timeline__content {
        padding-bottom: 12px;
    }

    .blog-feature {
        position: relative; /* Ensure the overlay positions relative to this container */
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        color: white;
    }

        .blog-feature > .overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.8); /* Black with 50% opacity */
            z-index: 1; /* Ensure it sits above the background image but below the text content */
        }

        /* Targeting only the direct .col-12 child of .blog-feature for text content */
        .blog-feature > .col-12 > div {
            position: relative;
            z-index: 2; /* Higher than overlay, to keep text visible and on top */
        }

    @charset "UTF-8";

    #Frames, .Frame {
        list-style: none;
        list-style-type: none;
        margin: 0px;
        padding: 0px;
        text-align: center;
    }

    #Frames {
        margin: 5% 0;
        width: 100%;
    }

    .Frame {
        display: inline-block;
        padding: 40px;
        border-width: 20px;
        border-style: solid;
        border-color: #2F2D2D #434040 #4F4C4C #434040;
        background: #f5f5f5;
        background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#E5E4DF), to(#CDCDC6));
        background-image: -webkit-linear-gradient(#E5E4DF, #CDCDC6);
        background-image: -moz-linear-gradient(#E5E4DF, #CDCDC6);
        background-image: -o-linear-gradient(#E5E4DF, #CDCDC6);
        background-image: linear-gradient(#E5E4DF, #CDCDC6);
        box-shadow: inset 0 2px 5px rgba(0,0,0,.6),0 5px 2px rgba(0,0,0,.1), 0 10px 20px rgba(0,0,0,.8);
        position: relative;
        overflow: hidden;
    }

        .Frame::before {
            content: "";
            position: absolute;
            top: -175px;
            right: -20%;
            width: 400px;
            height: 400px;
            transform: rotateZ(-40deg);
            -webkit-transform: rotateZ(-40deg);
            -moz-transform: rotateZ(-40deg);
            -o-transform: rotateZ(-40deg);
            background-image: -webkit-gradient(linear, 0 0, 0 100%, from(rgba(255,255,255,.4)), to(rgba(255,255,255,0)));
            background-image: -webkit-linear-gradient(rgba(255,255,255,.4), rgba(255,255,255,0));
            background-image: -moz-linear-gradient(rgba(255,255,255,.4), rgba(255,255,255,0));
            background-image: -o-linear-gradient(rgba(255,255,255,.4), rgba(255,255,255,0));
            background-image: linear-gradient(rgba(255,255,255,.4), rgba(255,255,255,0));
        }

        .Frame img {
            border-width: 2px;
            border-style: solid;
            border-color: #BBBAB4 #C7C7BF #E5E4DF #C7C7BF;
            box-shadow: 0 -1px 1px rgba(0,0,0,.1), 0 1px 1px 1px rgba(255,255,255,.7);
        }



    h1, h2, h3 {
        line-height:unset;
        margin: 0; /* Removes the default margin */
        font-size: unset; /* Resets the font size to the default for the document */
        font-weight: normal; /* Removes the bold styling */
        display: block; /* Although both h1, h2, and div are block-level elements by default, this is included for completeness */
    }

    /*-----------------------------
    Services Style3
-------------------------------*/
    .tc-services-style3 .services-item {
        padding: 30px 25px 25px;
        position: relative;
        text-align: center;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 25px;
    }

    .tc-services-style3 .services-icon {
        font-size: 42px;
        display: inline-block;
        color: #999;
        text-align: center;
        margin-bottom: 15px;
        -webkit-transition: all .3s ease-out;
        transition: all .3s ease-out;
    }

    .tc-services-style3 .services-title {
        background-color: #444;
        color: #fff;
 
        font-size: 17px;
        margin-bottom: 30px;
        margin-left: -25px;
        margin-right: -25px;
        -webkit-transition: all .3s ease-out;
        transition: all .3s ease-out;
    }

    .tc-services-style3 .services-item:hover .services-title {
        background-color: #222;
    }

    .tc-services-style3 .services-desc p {
        font-size: 14px;
        line-height: 1.8;
        color: #777;
    }

    .tc-services-style3 .services-desc a {
        position: relative;
        display: inline-block;
        color: #888;
        font-size: 11px;
        line-height: normal;
        border: 1px solid #e5e5e5;
        text-decoration: none !important;
        padding: 3px 10px;
        margin-top: 20px;
        -webkit-transition: all .3s ease-out;
        transition: all .3s ease-out;
    }

        .tc-services-style3 .services-desc a:hover {
            color: #222;
            border-color: #222;
        }




    /*----------------------------
    Calltoaction Styles
------------------------------*/
    .tc-calltoaction {
        padding: 25px 30px;
        background: #fff;
        min-height: 63px;
        border: 1px solid rgba(0,0,0,0.04);
        -webkit-box-shadow: -3px 0 0 rgba(0, 0, 0, 0.8);
        box-shadow: -3px 0 0 rgba(0, 0, 0, 0.8);
    }

        .tc-calltoaction .cta-button {
            display: inline-block;
            padding: 20px 30px;
            font-size: 16px;
            text-decoration: none;
            background-color: #444;
            color: #e5e5e5;
        }

            .tc-calltoaction .cta-button:hover {
                background-color: #000;
                color: #fff;
            }

        .tc-calltoaction h3 {
            font-size: 22px;
            line-height: 32px;
            margin: 0;
            color: #333;
        }

        .tc-calltoaction p {
            margin: 5px 0 0;
        }

        .tc-calltoaction:not(.cta-align-center) {
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -ms-flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            flex-wrap: wrap;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
        }

        .tc-calltoaction.cta-align-left {
            text-align: left;
        }

            .tc-calltoaction.cta-align-left .cta-button {
                margin-left: auto;
            }

        .tc-calltoaction.cta-align-right {
            text-align: right;
            -webkit-box-shadow: 3px 0 0 rgba(0, 0, 0, 0.8);
            box-shadow: 3px 0 0 rgba(0, 0, 0, 0.8);
        }

        .tc-calltoaction.cta-align-center {
            text-align: center;
            padding: 45px;
            -webkit-box-shadow: 0 -3px 0 rgba(0, 0, 0, 0.8);
            box-shadow: 0 -3px 0 rgba(0, 0, 0, 0.8);
        }

            .tc-calltoaction.cta-align-center h3 {
                font-size: 26px;
            }

            .tc-calltoaction.cta-align-center .cta-button {
                margin-top: 25px;
            }

            .tc-calltoaction.cta-align-center .cta-content > div {
                margin-top: 10px;
            }

        .tc-calltoaction.cta-radius {
            padding: 25px 40px;
            border-radius: 60px;
            -webkit-box-shadow: none;
            box-shadow: none;
        }

            .tc-calltoaction.cta-radius .cta-button {
                border-radius: 60px;
            }

    /*----------------------------
    Responsive Medium
------------------------------*/
    @media (min-width: 767px) {
        .tc-calltoaction:not(.cta-align-center) .cta-content {
            max-width: 75%;
        }

        .tc-calltoaction.cta-align-right a.cta-button {
            -ms-flex-order: -1;
            -webkit-order: -1;
            order: -1;
        }

        .tc-calltoaction.cta-align-right .cta-content {
            margin-left: auto;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 979px) {
        .tc-calltoaction:not(.cta-align-center) .cta-content {
            max-width: 70%;
        }
    }

    @media (max-width: 767px) {
        .tc-calltoaction .cta-button {
            margin: 18px 0 10px;
            text-align: center;
        }

        .tc-calltoaction .cta-content {
            text-align: center;
            margin-left: auto;
            margin-right: auto;
        }

        .tc-calltoaction.cta-align-left .cta-button {
            margin-right: auto;
        }

        .tc-calltoaction.cta-align-right .cta-button {
            margin-right: auto;
            margin-left: auto;
        }
    }

    @media only screen and (max-width: 480px) {
        .tc-calltoaction .cta-button {
            padding: 10px;
            margin: 18px 0 10px;
            font-size: 14px;
            text-align: center;
        }

        .tc-calltoaction .cta-content {
            text-align: center;
        }
    }


    .btn-links {
        transition: 0.5s;
    }

        .btn-links:after {
            content: '\00BB';
            position: absolute;
            font-size:16px;
            opacity: 0;
            right: -20px;
            transition: 0.5s;
        }

    .btn-links:hover {
        padding-right: 24px;
        padding-left: 8px;
    }

        .btn-links:hover:after {
            opacity: 1;
            right: 10px;
            top: 3px;
        }

    article {
        position: relative;
        max-width: 1200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 5px 10px;
    }

        article p {
            --accent: dodgerblue /*for text box borders*/;
            font-size: 10pt;
            line-height: 12pt;
            color: black;
            border-left: 3px solid var(--accent);
            padding: 5px 10px;
            background: #eee;
            font-weight: 300;
            font-family:Arial;
            
        }



   
</style>
